<template>
  <div class="container map-wrapper-c">
    <remote-js cdn="https://a.amap.com/Loca/static/mock/adcodes.js"></remote-js>
    <div class="c-absolute c-zindex-1 c-p-10">
      <el-popover placement="bottom-start" trigger="manual" v-model="visible">
        <div class="c-flex c-flex-end">
          <i class="el-icon-close closeHover" @click="visible = false" style="cursor: pointer"></i>
        </div>
        <div style="width: 300px;padding: 0 12px;line-height: 30px;">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="标记" name="markers">
              <template>
                <span class="c-font-13">选择你想在地图上看到的对象</span>
                <ul>
                  <el-checkbox-group v-model="layerEditor.checked" @change="layerEditorChange">
                    <li>
                      <el-checkbox label="checkedSA">服务工单</el-checkbox>
                    </li>
                    <!-- <li>
                      <el-checkbox label="checkedSTcustom">自定义服务区域</el-checkbox>
                    </li>-->
                    <!-- <li>
                      <el-checkbox label="checkedST">服务区域</el-checkbox>
                    </li>  -->
                    <li>
                      <el-checkbox label="checkedSR">服务资源</el-checkbox>
                    </li>
                    <!-- <li>
                        <el-checkbox label="checkedVIP">VIP客户</el-checkbox>
                      </li>
                      <li>
                        <el-checkbox label="checkedLead">线索</el-checkbox>
                      </li> -->
                  </el-checkbox-group>
                </ul>
              </template>
            </el-tab-pane>
            <!-- <el-tab-pane label="行政区域" name="second">行政区域</el-tab-pane> -->
            <el-tab-pane label="报表" name="third" style="min-height: 200px;">
              <div class="c-flex c-flex-between ">
                <el-select
                  v-model="reportData.value"
                  placeholder="请选择"
                  class="c-flex-1"
                  style="margin-right: 6px;"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="item in reportData.reportList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-button plain @click="addLayerReport">添加层</el-button>
              </div>
              <el-table
                :show-header="false"
                size="mini"
                :data="reportData.applicationFilter"
                style="width: 100%"
                max-height="200px"
              >
                <el-table-column prop="name" min-width="60">
                  <template slot-scope="scope">
                    <div
                      class="c-flex c-flex-between"
                      :class="{
                        c_gray: !scope.row.show
                      }"
                    >
                      <span>{{ scope.row.name }}</span>
                      <span>({{ scope.row.num }})</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column width="50">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      v-if="scope.row.show"
                      @click="reportApplicationFilterChange(scope.row, scope.$index)"
                    >
                      隐藏
                    </el-button>
                    <el-button
                      type="text"
                      v-else
                      @click="reportApplicationFilterChange(scope.row, scope.$index)"
                    >
                      显示
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column label="地址" width="50">
                  <template slot-scope="scope">
                    <el-button type="text" @click="delReportApplicationFilterBtn(scope.$index)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div
                class="c-flex"
                style="justify-content: center;"
                v-if="reportData.applicationFilter.length"
              >
                <el-button type="text" @click="delReportApplicationFilterBtn('all')">
                  全部删除
                </el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="服务区域" name="fourth">
              <!-- <div class="c-flex" style="margin-top:10px">
                <ul>
                  <el-checkbox-group v-model="layerEditor.checked" @change="layerEditorChange">
                    <li>
                      <el-checkbox label="checkedST">服务区域</el-checkbox>
                    </li>
                  </el-checkbox-group>
                </ul>
              </div> -->
              <el-button
                type="text"
                @click="clearAllST"
                v-if="
                  serviceTerritories.data &&
                    serviceTerritories.data.length &&
                    layerEditor.STmarkerList.length
                "
              >
                全部清空
              </el-button>
              <el-pagination
                small
                @current-change="pageChange($event, 'serviceTerritories', getServiceTerritory)"
                layout="prev, pager, next"
                :current-page="serviceTerritories.page"
                :page-size="20"
                :total="serviceTerritories.total"
              ></el-pagination>
              <div style="height:300px;overflow-y: auto;">
                <el-tree
                  class="c-w-1"
                  :default-expand-all="true"
                  :data="serviceTerritories.data"
                  show-checkbox
                  node-key="_id"
                  ref="areaSTtree"
                  :props="{ children: 'children', label: 'name' }"
                  @check-change="handleSTCheckChange"
                  :default-checked-keys="defaultSTChecked"
                ></el-tree>
              </div>
            </el-tab-pane>
            <el-tab-pane label="自定义服务区域" name="five">
              <div class="c-flex">
                <el-input
                  size="small"
                  v-model="customDrawData.name"
                  placeholder="请输入"
                ></el-input>
                <el-color-picker
                  :popper-append-to-body="false"
                  style="margin-left: 4px;"
                  v-model="customDrawData.exts.fillColor"
                  show-alpha
                  ref="colorPicker"
                ></el-color-picker>
                <el-button-group size="mini" class="c-flex c-m-l-15">
                  <el-button size="mini" @click="drawPolygon()">新增</el-button>
                  <!-- <el-button size="mini">保存</el-button> -->
                  <!-- <el-button size="mini" @click="closeDraw()">清空</el-button> -->
                </el-button-group>
              </div>
              <div class="c-flex" style="margin-top:10px">
                <!-- c-absolute c-zindex-1 c-p-10 c_absolute_right -->
                <el-select
                  v-model="selectAdcode"
                  @change="initPro(selectAdcode, selectDepth)"
                  placeholder="请选择"
                  class="c-m-r-10"
                >
                  <el-option
                    v-for="item in adcodes"
                    :key="item.adcode"
                    :label="item.name"
                    :value="item.adcode"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="selectDepth"
                  @change="initPro(selectAdcode, selectDepth)"
                  placeholder="请选择"
                >
                  <el-option label="显示省级" value="0"></el-option>
                  <el-option label="显示市级" value="1"></el-option>
                  <el-option label="显示区/县级" value="2"></el-option>
                </el-select>
              </div>
              <div class="c-flex" style="overflow-y: auto;height: 300px;margin-top:10px">
                <el-tree
                  class="c-w-1"
                  :default-expand-all="true"
                  :data="customizeAreaList"
                  show-checkbox
                  node-key="_id"
                  ref="areaTree"
                  :props="{ children: 'children', label: 'name' }"
                  @check-change="handleCheckChange"
                  :default-checked-keys="defaultChecked"
                ></el-tree>
              </div>
              <div
                class="c-flex map-area-tree-wrapper"
                v-if="layerEditor.checked.includes('checkedST')"
              >
                <div id="outer-box">
                  <div id="container" tabindex="0"></div>
                  <div id="panel" class="scrollbar1">
                    <ul id="area-tree"></ul>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-button slot="reference" @click="visible = !visible">
          图层编辑器
          <i
            :class="{
              'el-icon-caret-bottom': !visible,
              'el-icon-caret-top': visible
            }"
          ></i>
        </el-button>
      </el-popover>

      <p>说明：已定位个数 / 查询到总数</p>
      <p>工单：{{ layerEditor.SAmarkerList.length }} / {{ SAData.length }}</p>
      <!-- <p>
        人员：{{ userData.length - userNo.length < 0 ? 0 : userData.length - userNo.length }} /
        {{ userData.length }}
      </p> -->
      <p v-if="layerEditor.lastChecked.includes('checkedSR')">
        服务资源：{{ resourcesList.length }}
      </p>
    </div>

    <div id="map"></div>
    <el-dialog
      :visible.sync="mapAlertData.openDetail"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      id="mapAler-dialog"
      :class="{ 'mapAler-dialog-noneFooter': mapAlertData.activeName != '10' }"
    >
      <div slot="title">
        <!-- -->
        <el-tabs v-model="mapAlertData.activeName" @tab-click="tabClick">
          <el-tab-pane :label="formData.orderNum" name="10">
            <c-form
              :formData="formData"
              :fields="extFields"
              :options="options"
              ref="form"
              :upload="upload"
              labelWidth="100px"
              :area="area"
            >
              <template slot="area">
                <el-cascader
                  popper-class="cascaderLabelHide-wrapper"
                  ref="areaSelector"
                  :options="area.options"
                  :props="{
                    checkStrictly: false,
                    expandTrigger: 'hover'
                  }"
                  v-model="formData.area"
                  clearable
                  @change="
                    if (formData.subdistrict) {
                      formData.subdistrict = '';
                    }
                    osg.getSubdistricts(formData.area, result => {
                      options.subdistricts = result;
                      $forceUpdate();
                    });
                  "
                ></el-cascader>
              </template>
              <template></template>
              <template slot="address">
                <el-input
                  v-model="formData.address"
                  suffix-icon="el-icon-map-location"
                  @blur="getGeocode"
                ></el-input>
              </template>
              <template slot="channel">
                <el-cascader
                  clearable
                  v-model="formData.channel"
                  :options="options.channel"
                  :props="{ expandTrigger: 'hover', label: 'name' }"
                ></el-cascader>
              </template>
            </c-form>
            <!-- <div slot="footer">
              <el-button type="primary" @click="doSave">确 定</el-button>
              <el-button @click="doInit">取 消</el-button>
            </div> -->
          </el-tab-pane>
          <!-- <el-tab-pane label="服务预约" name="20">服务预约</el-tab-pane> -->
          <el-tab-pane label="业务动态" name="log">
            <div class="box-center-tool">
              <div>
                <el-date-picker
                  v-model="log.searchDate"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  clearable
                  @change="getLog"
                  class="search-date"
                ></el-date-picker>
              </div>
              <div class="m-t-10">
                <el-input
                  placeholder="请输入标题/内容"
                  v-model="log.searchValue"
                  class="search-input"
                  clearable
                  @clear="getLog"
                  @keyup.enter.native="getLog"
                >
                  <el-button slot="append" icon="el-icon-search" @click="getLog"></el-button>
                </el-input>
              </div>
            </div>
            <div class="box-center-content">
              <div class="activity-card" v-for="(log, i) in log.fpi.data" :key="i">
                <div class="activity-card-header">
                  <span class="c-font-500">
                    <i class="el-icon-monitor c-w-30"></i>
                    {{ log.title }}
                  </span>
                  <span>{{ log.createTime }}</span>
                </div>

                <div v-if="log.extData && log.extData.length > 0" class="activity-card-content">
                  <!-- {{ log.content }} -->
                  <div class v-for="(sub, ui) in log.extData" :key="ui">
                    <div>{{ sub.name }} : {{ sub.value }}</div>
                  </div>
                </div>
                <div v-else class="activity-card-content">
                  {{ log.content || '' }}
                </div>
                <div class="activity-card-footer">
                  <span>操作人：{{ log.createUserName }}</span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="相关" name="40">相关</el-tab-pane> -->
          <el-tab-pane label="地图" name="map">
            <div class="m-b-10 box-center-tool">
              <div></div>
              <el-button
                v-if="false"
                @click.native.prevent="
                  mapAlertData.openAlertMapRouter = !mapAlertData.openAlertMapRouter
                "
              >
                {{ mapAlertData.openAlertMapRouter ? '关闭' : '查看' }}路线
              </el-button>
            </div>
            <div id="mapAlert"></div>
            <div id="panel-alertMapRouter" v-show="mapAlertData.openAlertMapRouter"></div>
          </el-tab-pane>
          <el-tab-pane label="客户" name="contact">
            <div class="content-table">
              <el-table
                ref="table"
                height="calc(100% - 50px)"
                :data="fpi.data"
                v-if="contactsExtFields.length"
              >
                <c-table :fields="contactsExtFields">
                  <template slot="name">
                    <el-table-column
                      label="姓名"
                      width="120"
                      fixed
                      show-overflow-tooltip
                      prop="name"
                    >
                      <template slot-scope="scope">
                        <el-button
                          @click.native.prevent="
                            $router.push({ path: `/contact/${scope.row._id}` })
                          "
                          type="text"
                        >
                          {{ scope.row.name }}
                        </el-button>
                      </template>
                    </el-table-column>
                  </template>
                </c-table>
              </el-table>
              <el-pagination
                class="pagination"
                @size-change="pageSizeChange"
                @current-change="pageChange"
                :current-page="fpi.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="fpi.rows"
                layout="total, sizes, prev, pager, next, jumper"
                :total="fpi.total"
              ></el-pagination>
            </div>
          </el-tab-pane>
        </el-tabs>
        <!-- <div slot="footer">
        <el-button type="primary" @click="doSaveSA">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div> -->
      </div>
      <div slot="footer">
        <div>
          <el-button type="primary" @click="doSaveSA">确 定</el-button>
          <el-button @click="mapAlertData.openDetail = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="自定义服务区域信息" :visible.sync="openCustomDrawDetail">
      <el-form
        :model="customDrawData"
        :rules="rules"
        ref="customDrawForm"
        label-width="110px"
        label-position="left"
        hide-required-asterisk:true
      >
        <el-form-item label="名称" prop="name">
          <el-input size="small" v-model="customDrawData.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="覆盖颜色" prop="longitude">
          <el-color-picker
            :popper-append-to-body="false"
            style="margin-left: 4px;"
            v-model="customDrawData.exts.fillColor"
            show-alpha
            ref="colorPicker"
          ></el-color-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doServiceTerritoryCustomBtn">确 定</el-button>
        <el-button @click="openCustomDrawDetail = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import areajs from '../resources/js/area.js';
// import Template from '../views/Template.vue';
//设置
export default {
  components: {
    'remote-js': {
      render(createElement) {
        return createElement('script', {
          attrs: {
            type: 'text/javascript',
            src: this.cdn
          }
        });
      },
      props: {
        cdn: {
          type: String,
          required: true
        }
      }
    },
    'remote-css': {
      render(createElement) {
        return createElement('link', {
          attrs: {
            rel: 'stylesheet',
            type: 'text/css',
            href: this.cdn
          }
        });
      },
      props: {
        cdn: {
          type: String,
          required: true
        }
      }
    }
  },
  Templateame: 'c-map',
  data() {
    return {
      rules: this.$util.rules,
      map: null,
      mapAlert: null, //弹窗里的地图
      SAData: [],
      userData: [],
      SANo: [],
      userNo: [],
      markers: [],
      disProvince: null,
      adCode: '',
      depth: '',
      adcodes: [],
      selectAdcode: 100000,
      selectDepth: '0',
      mouseTool: null, //绘制地图对象
      //图层编辑器
      layerEditor: {
        SAmarkerList: [], //工单标记图层
        STmarkerList: [], //服务区域
        STcustommarkerList: [], //自定义服务区域标记图层
        SRmarkerList: [], //服务资源标记图层
        VIPmarkerList: [], //VIP客户标记图层
        leadMarkerList: [], //显示标记图层
        checked: [], //是否选中
        lastChecked: [], //上次被选中的数组
        administrativeRegion: [], //行政区域
        administrativeRegion$: null //行政区域JQ
      },
      activeName: 'markers',
      // 服务资源的模拟经纬度数据
      resourcesList: [
        {
          gpsPoint: {
            longitude: 115.820646,
            latitude: 39.704566
          }
        },
        {
          gpsPoint: {
            longitude: 115.952482,
            latitude: 39.873405
          }
        },
        {
          gpsPoint: {
            longitude: 115.996427,
            latitude: 40.053941
          }
        },
        {
          gpsPoint: {
            longitude: 116.699552,
            latitude: 40.053941
          }
        },
        {
          gpsPoint: {
            longitude: 116.34799,
            latitude: 39.513619
          }
        },
        {
          gpsPoint: {
            longitude: 117.314786,
            latitude: 40.523236
          }
        },
        {
          gpsPoint: {
            longitude: 114.897794,
            latitude: 39.986632
          }
        },
        {
          gpsPoint: {
            longitude: 113.491544,
            latitude: 39.479708
          }
        },
        {
          gpsPoint: {
            longitude: 113.183927,
            latitude: 34.823995
          }
        },
        {
          gpsPoint: {
            longitude: 106.987638,
            latitude: 33.331721
          }
        },
        {
          gpsPoint: {
            longitude: 105.889005,
            latitude: 31.850778
          }
        },
        {
          gpsPoint: {
            longitude: 107.778654,
            latitude: 31.063569
          }
        },
        {
          gpsPoint: {
            longitude: 114.678068,
            latitude: 31.063569
          }
        },
        {
          gpsPoint: {
            longitude: 119.336271,
            latitude: 31.176432
          }
        },
        {
          gpsPoint: {
            longitude: 120.65463,
            latitude: 31.589111
          }
        },
        {
          gpsPoint: {
            longitude: 119.555997,
            latitude: 31.514213
          }
        },
        {
          gpsPoint: {
            longitude: 119.599943,
            latitude: 30.799701
          }
        },
        {
          gpsPoint: {
            longitude: 120.434904,
            latitude: 30.724176
          }
        },
        {
          gpsPoint: {
            longitude: 121.006193,
            latitude: 30.875166
          }
        },
        {
          gpsPoint: {
            longitude: 119.555997,
            latitude: 32.557277
          }
        },
        {
          gpsPoint: {
            longitude: 109.272794,
            latitude: 32.44609
          }
        },
        {
          gpsPoint: {
            longitude: 99.253263,
            latitude: 32.594309
          }
        },
        {
          gpsPoint: {
            longitude: 99.912443,
            latitude: 30.837441
          }
        },
        {
          gpsPoint: {
            longitude: 99.253263,
            latitude: 35.792241
          }
        },
        {
          gpsPoint: {
            longitude: 97.890958,
            latitude: 36.501953
          }
        },
        {
          gpsPoint: {
            longitude: 100.527677,
            latitude: 36.501953
          }
        },
        {
          gpsPoint: {
            longitude: 104.306974,
            latitude: 35.327495
          }
        },
        {
          gpsPoint: {
            longitude: 104.306974,
            latitude: 33.331721
          }
        },
        {
          gpsPoint: {
            longitude: 107.690763,
            latitude: 33.331721
          }
        },
        {
          gpsPoint: {
            longitude: 110.107755,
            latitude: 32.816178
          }
        },
        {
          gpsPoint: {
            longitude: 119.204435,
            latitude: 36.395906
          }
        },
        {
          gpsPoint: {
            longitude: 107.383146,
            latitude: 27.927736
          }
        },
        {
          gpsPoint: {
            longitude: 111.426115,
            latitude: 22.848387
          }
        },
        {
          gpsPoint: {
            longitude: 110.371427,
            latitude: 22.848387
          }
        },
        {
          gpsPoint: {
            longitude: 111.777677,
            latitude: 22.1989
          }
        },
        {
          gpsPoint: {
            longitude: 115.996427,
            latitude: 23.494786
          }
        },
        {
          gpsPoint: {
            longitude: 113.53549,
            latitude: 23.977519
          }
        },
        {
          gpsPoint: {
            longitude: 111.426115,
            latitude: 23.977519
          }
        },
        {
          gpsPoint: {
            longitude: 112.480802,
            latitude: 23.977519
          }
        },
        {
          gpsPoint: {
            longitude: 105.976896,
            latitude: 24.937552
          }
        },
        {
          gpsPoint: {
            longitude: 101.582365,
            latitude: 29.927612
          }
        },
        {
          gpsPoint: {
            longitude: 105.273771,
            latitude: 29.622462
          }
        }
      ],
      // 服务区域列表
      serviceTerritories: [],
      //自定义服务区域列表
      customizeAreaList: [
        {
          _id: 110000,
          label: 'ces1',
          customPoints: [
            { longitude: 113.557462, latitude: 39.155111 },
            { longitude: 115.491056, latitude: 38.194503 },
            { longitude: 115.337247, latitude: 39.630568 }
          ],
          children: []
        }
      ],
      //报表数据
      reportData: {
        //下拉选择值
        value: '',
        //下拉选择列表
        reportList: [
          // {
          //   value: '1',
          //   label: '管理的资产',
          //   num: 12
          // },
          {
            value: '2',
            label: 'VIP客户',
            num: 1
          },
          {
            value: '3',
            label: '可在24小时内跟进的线索',
            num: 3
          }
        ],
        //应用的过滤条件
        applicationFilter: [
          // {
          //   value: '1',
          //   name: '管理的资产',
          //   num: 12,
          //   show: true
          // },
          // {
          //   value: '2',
          //   name: 'VIP客户',
          //   num: 8,
          //   show: true
          // },
          // {
          //   value: '3',
          //   name: '可在24小时内跟进的线索',
          //   num: 8,
          //   show: true
          // }
        ]
      },
      //绘制自定义区域数据
      customDrawData: {
        name: '自定义1',
        customPoints: [],
        exts: { fillColor: '#FB4300' }
      },
      visible: false, //图层编辑器的显示隐藏
      //消息弹窗
      mapAlertData: {
        openDetail: false, //弹窗
        activeName: '10',
        openAlertMapRouter: false, //查看路线
        row: {}
      },
      formData: { exts: {} }, //工单表单
      extFields: [], //工单扩展
      contactsExtFields: [], //客户扩展
      options: {},
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      //地址级联-懒加载
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      // 日志
      log: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: []
      },
      fpi: {
        data: []
      },
      contactVIPlist: [], //VIP客户列表
      leadList: [], //线索列表
      defaultChecked: [], //默认选中-自定义服务区域
      defaultSTChecked: [], //默认选中-服务区域
      openCustomDrawDetail: false
    };
  },
  mounted() {
    this.getServiceTerritory(); //服务区域
    this.getResources(); //服务资源
    this.getVIPContact(); //VIP客户列表
    this.getLead(); //获取线索列表
    this.getServiceTerritoryCustom(); //查询自定义服务区域列表
  },
  methods: {
    doInit() {
      let _this = this;
      // 高德地图的信息弹窗中的查看详情的按钮，事件回调
      window.viewDetail = sid => {
        _this.mapAlertData.openDetail = true; //打开信息弹窗
        this.mapAlertData.activeName = '10';
        // this.$nextTick(() => {
        this.getSAinit(sid, row => {
          this.mapAlertData.row = row;
          // this.initMap('mapAlert', { formData: row }, () => {
          //   this.$forceUpdate();
          //   this.addSRmark({ name: 'mapAlert' }); //添加服务资源标点
          //   this.addSAmarkerAlert({ name: 'mapAlert', formData: row }); //添加工单标点
          // });
        }); //初始化工单信息
        // });
      };
      this.SANo = [];
      this.userNo = [];
      this.markers = [];
    },
    initMap(mapName, mapData, callback) {
      mapName = mapName || 'map';
      mapData = mapData || { formData: { gpsPoint: {} } };
      this.doInit();
      this[mapName] = new AMap.Map(mapName, {
        center:
          mapData.formData.gpsPoint &&
          mapData.formData.gpsPoint.longitude &&
          mapData.formData.gpsPoint.latitude
            ? [mapData.formData.gpsPoint.longitude, mapData.formData.gpsPoint.latitude]
            : [116.397428, 39.90923], //中心点坐标
        zooms: [0, 18], //设置地图级别范围
        zoom: 8 //级别
      });

      //设置DomLibrary，jQuery或者Zepto
      AMapUI.load(['lib/$'], function($) {
        AMapUI.setDomLibrary($);
      });

      // 工具栏
      /*AMap.plugin(["AMap.ToolBar", "AMap.Scale"], () => {
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        this.map.addControl(new AMap.ToolBar());
        // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
        this.map.addControl(new AMap.Scale());
      });*/

      //简易行政区域
      AMap.plugin(['AMap.DistrictLayer'], () => {
        this.adcodes = adcodes;
        this.initPro(this.selectAdcode, this.selectDepth);
      });

      // 缩放控件
      AMapUI.loadUI(['control/BasicControl'], BasicControl => {
        let zoomCtrl = new BasicControl.Zoom({
          position: 'br'
        });
        this[mapName].addControl(zoomCtrl);
      });

      // //添加工单标记
      // this.addSAMarker();
      // console.log(
      //   this.SAData.filter(
      //     item =>
      //       item.gpsPoint &&
      //       item.gpsPoint.longitude &&
      //       item.gpsPoint.longitude != '0' &&
      //       item.gpsPoint.latitude &&
      //       item.gpsPoint.latitude != '0'
      //   )
      // );
      // debugger;
      if (callback) callback();
    },
    // 工单点标记
    addSAMarker() {
      AMapUI.loadUI(['overlay/AwesomeMarker'], AwesomeMarker => {
        //工单
        for (let item of this.SAData) {
          if (
            item.gpsPoint &&
            item.gpsPoint.longitude &&
            item.gpsPoint.longitude != '0' &&
            item.gpsPoint.latitude &&
            item.gpsPoint.latitude != '0'
          ) {
            // 创建点标记
            let marker = new AwesomeMarker({
              awesomeIcon: 'home',
              iconLabel: {
                style: {
                  color: '#fff',
                  fontSize: '14px'
                }
              },
              iconStyle: 'red',
              map: this.map,
              position: [item.gpsPoint.longitude, item.gpsPoint.latitude],
              title: '工单'
            });
            //记录标记的点
            this.layerEditor.SAmarkerList.push(marker);
            // 创建信息窗口
            marker.on('mouseover', () => {
              let infoWindow = new AMap.InfoWindow({
                isCustom: true, //使用自定义窗体
                content: `<div style="background-color: #fff;padding: 10px;border-radius:5px;">
                              <div><a href="/serviceAppointment/${
                                item._id
                              }" target="_blank" style="color:#409EFF;">标题：${
                  item.title
                }</a></div>
                              <div>姓名：${item.name}</div>
                              <div>手机：${item.phone}</div>
                              <div class="amap-btn-fsgo" onclick="viewDetail('${String(
                                item._id
                              )}')">查看详情</div>
                          </div>`,
                offset: new AMap.Pixel(-15, -25)
              });
              infoWindow.open(this.map, [item.gpsPoint.longitude, item.gpsPoint.latitude]);
              marker.on('mouseout', () => {
                infoWindow.close(this.map, [item.gpsPoint.longitude, item.gpsPoint.latitude]);
              });
            });
          } else {
            // 无定位工单
            this.SANo.push(item);
          }
        }

        //劳务人员
        for (let item of this.userData) {
          if (
            item.gpsPoint &&
            item.gpsPoint.longitude &&
            item.gpsPoint.longitude != '0' &&
            item.gpsPoint.latitude &&
            item.gpsPoint.latitude != '0'
          ) {
            // 创建点标记
            let marker = new AwesomeMarker({
              awesomeIcon: 'user-circle-o',
              iconLabel: {
                style: {
                  color: '#fff',
                  fontSize: '14px'
                }
              },
              iconStyle: 'orange',
              map: this.map,
              position: [item.gpsPoint.longitude, item.gpsPoint.latitude],
              title: '劳务资源'
            });

            // 创建信息窗口
            marker.on('mouseover', () => {
              let infoWindow = new AMap.InfoWindow({
                isCustom: true, //使用自定义窗体
                content: `<div style="background-color: #fff;padding: 10px;border-radius:5px;">
                              <div>姓名：${item.name}</div>
                              <div>手机：${item.phone}</div>
                          </div>`,
                offset: new AMap.Pixel(-15, -25)
              });
              infoWindow.open(this.map, [item.gpsPoint.longitude, item.gpsPoint.latitude]);
              marker.on('mouseout', () => {
                infoWindow.close(this.map, [item.gpsPoint.longitude, item.gpsPoint.latitude]);
              });
            });
          } else {
            // 无定位人员
            this.userNo.push(item);
          }
        }
      });
    },
    //弹窗-工单标记
    addSAmarkerAlert(mapData) {
      mapData = mapData || {};
      mapData = {
        name: mapData.name || 'map',
        formData: mapData.formData
      };
      if (mapData.formData.gpsPoint) {
        AMapUI.loadUI(['overlay/AwesomeMarker'], AwesomeMarker => {
          // 创建点标记
          let marker = new AwesomeMarker({
            awesomeIcon: 'home',
            iconLabel: {
              style: {
                color: '#fff',
                fontSize: '14px'
              }
            },
            iconStyle: 'red',
            map: this[mapData.name],
            position: [mapData.formData.gpsPoint.longitude, mapData.formData.gpsPoint.latitude],
            title: '工单'
          });
          // 创建信息窗口
          marker.on('mouseover', () => {
            let infoWindow = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: `<div style="background-color: #fff;padding: 10px;border-radius:5px;">
                              <div><a href="/serviceAppointment/${mapData.formData._id}" target="_blank" style="color:#409EFF;">标题：${mapData.formData.title}</a></div>
                              <div>姓名：${mapData.formData.name}</div>
                              <div>手机：${mapData.formData.phone}</div>
                          </div>`,
              offset: new AMap.Pixel(-15, -25)
            });
            infoWindow.open(this[mapData.name], [
              mapData.formData.gpsPoint.longitude,
              mapData.formData.gpsPoint.latitude
            ]);
            marker.on('mouseout', () => {
              infoWindow.close(this[mapData.name], [
                mapData.formData.gpsPoint.longitude,
                mapData.formData.gpsPoint.latitude
              ]);
            });
          });
        });
        let difference = Infinity; //差值
        let differenceData = {}; //最近的服务资源
        this.resourcesList.forEach(item => {
          if (
            Math.abs(mapData.formData.gpsPoint.longitude - item.gpsPoint.longitude) < difference ||
            Math.abs(mapData.formData.gpsPoint.longitude - item.gpsPoint.longitude) == difference
          ) {
            difference = Math.abs(mapData.formData.gpsPoint.longitude - item.gpsPoint.longitude);
            differenceData = item;
            // resourcesData = item;
          }
        });
        //绘制路线、行动轨迹
        if (mapData.name == 'mapAlert') {
          this.routeDraw(
            'mapAlert',
            differenceData.gpsPoint,
            mapData.formData.gpsPoint,
            mapData.formData.createTime,
            list => {
              this.trajectory(list, differenceData.name);
            }
          );
        }
      }
      //记录标记的点
      // this.layerEditor.SAmarkerList.push(marker);
    },
    // 绘制路线
    routeDraw(mapName, startLngLat, endLngLat, createTime, callback) {
      // debugger;
      // 构造路线导航类;
      var driving = new AMap.Driving({
        // map: this[mapName],
        // panel: 'panel-alertMapRouter',
        hideMarkers: true
      });
      // 根据起终点经纬度规划驾车导航路线
      driving.search(
        new AMap.LngLat(startLngLat.longitude, startLngLat.latitude),
        new AMap.LngLat(endLngLat.longitude, endLngLat.latitude),
        function(status, result) {
          console.log(result);
          let tujing = result.routes[0].steps;
          //           lat: 28.227491
          // lng: 112.935764
          //   {
          //                 name: '点g',
          //                 lnglat: [101.135432, 42.930601]
          //               },

          if (callback)
            callback([
              {
                name: `打卡时间：${createTime.substr(0, 10)} 09:27:04`,
                lnglat: [tujing[0].end_location.lng, tujing[0].end_location.lat]
              },
              {
                name: `打卡时间：${createTime.substr(0, 10)} 11:18:46`,
                lnglat: [tujing[4].end_location.lng, tujing[4].end_location.lat]
              },
              {
                name: `打卡时间：${createTime.substr(0, 10)} 13:42:34`,
                lnglat: [tujing[6].end_location.lng, tujing[6].end_location.lat]
              },
              {
                name: `打卡时间：${createTime.substr(0, 10)} 15:38:11`,
                lnglat: [tujing[8].end_location.lng, tujing[8].end_location.lat]
              },
              {
                name: `打卡时间：${createTime.substr(0, 10)} 17:55:33`,
                lnglat: [
                  tujing[tujing.length - 1].end_location.lng,
                  tujing[tujing.length - 1].end_location.lat
                ]
              }
            ]);
          // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
          // if (status === 'complete') {
          //     log.success('绘制驾车路线完成')
          // } else {
          //     log.error('获取驾车数据失败：' + result)
          // }
        }
      );

      // //步行导航
      // var walking = new AMap.Walking({
      //   map:  this[mapName],
      //   panel: 'panel'
      // });
      // //根据起终点坐标规划步行路线
      // walking.search([startLngLat.longitude, startLngLat.latitude], [endLngLat.longitude, endLngLat.latitude], function(status, result) {
      //   // result即是对应的步行路线数据信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_WalkingResult
      //   if (status === 'complete') {
      //     log.success('绘制步行路线完成');
      //   } else {
      //     log.error('步行路线数据查询失败' + result);
      //   }
      // });
    },
    //行为轨迹
    trajectory(list, mockName) {
      let that = this;
      //https://lbs.amap.com/demo/amap-ui/demos/amap-ui-pathsimplifier/simple-data
      AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], function(PathSimplifier, $) {
        if (!PathSimplifier.supportCanvas) {
          alert('当前环境不支持 Canvas！');
          return;
        }

        var pathSimplifierIns = new PathSimplifier({
          zIndex: 100,
          //autoSetFitView:false,
          map: that.mapAlert, //所属的地图实例

          getPath: function(pathData, pathIndex) {
            var points = pathData.points,
              lnglatList = [];

            for (var i = 0, len = points.length; i < len; i++) {
              lnglatList.push(points[i].lnglat);
            }

            return lnglatList;
          },
          getHoverTitle: function(pathData, pathIndex, pointIndex) {
            if (pointIndex >= 0) {
              //point
              return pathData.name + '，' + pathData.points[pointIndex].name;
            }

            return pathData.name + '，打卡次数' + pathData.points.length;
          },
          renderOptions: {
            renderAllPointsIfNumberBelow: 100 //绘制路线节点，如不需要可设置为-1
          }
        });

        window.pathSimplifierIns = pathSimplifierIns;

        //设置数据
        pathSimplifierIns.setData([
          {
            name: mockName,
            points: list || [
              {
                name: '点a',
                lnglat: [116.405289, 39.904987]
              },
              {
                name: '点b',
                lnglat: [113.964458, 40.54664]
              },
              {
                name: '点c',
                lnglat: [111.47836, 41.135964]
              },
              {
                name: '点d',
                lnglat: [108.949297, 41.670904]
              },
              {
                name: '点e',
                lnglat: [106.380111, 42.149509]
              },
              {
                name: '点f',
                lnglat: [103.774185, 42.56996]
              },
              {
                name: '点g',
                lnglat: [101.135432, 42.930601]
              },
              {
                name: '点h',
                lnglat: [98.46826, 43.229964]
              },
              {
                name: '点i',
                lnglat: [95.777529, 43.466798]
              },
              {
                name: '点j',
                lnglat: [93.068486, 43.64009]
              },
              {
                name: '点k',
                lnglat: [90.34669, 43.749086]
              },
              {
                name: '点l',
                lnglat: [87.61792, 43.793308]
              }
            ]
          }
        ]);

        //选中路线0
        pathSimplifierIns.setSelectedPathIndex(0);

        pathSimplifierIns.on('pointClick', function(e, info) {
          console.log('Click: ' + info.pathData.points[info.pointIndex].name);
        });

        // 调整地图缩放
        // that.mapAlert.setZoom(11);
        // that.mapAlert.setView();
        // that.mapAlert.setFitView(null, false, [160, 60, 100, 60]);
        // pathSimplifierIns.setFitView(1);
      });
    },
    //新增客户标记
    addContact() {
      AMapUI.loadUI(['overlay/AwesomeMarker'], AwesomeMarker => {
        this.contactVIPlist.forEach((pItem, index) => {
          // console.log(pItem);
          if (!pItem.gpsPoint) {
            return;
          }
          // debugger;
          // 创建点标记
          let marker = new AwesomeMarker({
            // awesomeIcon: 'female', //穿裙子的人
            // awesomeIcon: 'truck',//卡车
            awesomeIcon: 'address-book', //地址薄
            iconLabel: {
              style: {
                color: '#fff',
                fontSize: '14px'
              }
            },
            iconStyle: 'orange',
            map: this.map,
            position: [pItem.gpsPoint.longitude, pItem.gpsPoint.latitude],
            title: 'VIP客户'
          });
          this.layerEditor.VIPmarkerList.push(marker);
          //记录标记的点
          // 创建信息窗口
          marker.on('mouseover', () => {
            let infoWindow = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: `<div style="background-color: #fff;padding: 10px;border-radius:5px;">
                              <div>姓名：${pItem.name}</div>
                              <div>手机：${pItem.phone || 13400000000}</div>
                          </div>`,
              offset: new AMap.Pixel(-15, -25)
            });
            infoWindow.open(this.map, [pItem.gpsPoint.longitude, pItem.gpsPoint.latitude]);
            marker.on('mouseout', () => {
              infoWindow.close(this.map, [pItem.gpsPoint.longitude, pItem.gpsPoint.latitude]);
            });
          });
        });
      });
    },
    //获取服务资源
    getResources() {
      let params = {
        'exists:gpsPoint|boolean#and': true,
        'in:state|array-integer#and': '1',
        'is:resourceType|string#and': 'technician',
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax('biz/serviceResource/query.do', params, res => {
        this.resourcesList = res.data;
      });
    },
    //VIP客户列表
    getVIPContact() {
      let params = {
        'exists:gpsPoint|boolean#and': true,
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax('basic/contacts/query.do', params, res => {
        this.contactVIPlist = res.data;
        this.reportData.reportList[0].num = res.data.length; //报表查询条件取真实的客户总长度
      });
    },
    //线索泪奔
    getLead() {
      let params = {
        'exists:gpsPoint|boolean#and': true,
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc',
        _all: '1'
      };
      this.osg.ajax('basic/lead/query.do', params, res => {
        this.leadList = res.data;
        this.reportData.reportList[1].num = res.data.length; //报表查询条件取线索总长度
      });
    },
    //新增服务资源标记
    addSRmark(mapData) {
      mapData = mapData || {};
      mapData = {
        name: mapData.name || 'map'
      };
      // this.getPartner(pList => {
      AMapUI.loadUI(['overlay/AwesomeMarker'], AwesomeMarker => {
        this.resourcesList.forEach((pItem, index) => {
          // console.log(pItem);
          if (!pItem.gpsPoint) {
            return;
          }
          // debugger;
          // 创建点标记
          let marker = new AwesomeMarker({
            // awesomeIcon: 'female', //穿裙子的人
            // awesomeIcon: 'truck', //卡车
            awesomeIcon: 'street-view', //
            // awesomeIcon: 'address-book', //地址薄
            iconLabel: {
              style: {
                color: '#fff',
                fontSize: '14px'
              }
            },
            iconStyle: 'black',
            map: this[mapData.name],
            position: [pItem.gpsPoint.longitude, pItem.gpsPoint.latitude],
            title: '服务资源'
          });
          this.layerEditor.SRmarkerList.push(marker);
          //记录标记的点
          // 创建信息窗口
          marker.on('mouseover', () => {
            let infoWindow = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: `<div style="background-color: #fff;padding: 10px;border-radius:5px;">
                              <div>名称：${pItem.name}</div>
                              <div>资源类型：技师</div>
                          </div>`,
              offset: new AMap.Pixel(-15, -25)
            });
            infoWindow.open(this[mapData.name], [
              pItem.gpsPoint.longitude,
              pItem.gpsPoint.latitude
            ]);
            marker.on('mouseout', () => {
              infoWindow.close(this[mapData.name], [
                pItem.gpsPoint.longitude,
                pItem.gpsPoint.latitude
              ]);
            });
          });
        });
      });
      // });
    },
    //新增服务资源标记
    addLeadMark() {
      // this.getPartner(pList => {
      AMapUI.loadUI(['overlay/AwesomeMarker'], AwesomeMarker => {
        this.leadList.forEach((pItem, index) => {
          // console.log(pItem);
          if (!pItem.gpsPoint || !pItem.name) {
            return;
          }
          // debugger;
          // 创建点标记
          let marker = new AwesomeMarker({
            awesomeIcon: 'user',
            iconLabel: {
              style: {
                color: '#fff',
                fontSize: '14px'
              }
            },
            iconStyle: 'salmon',
            map: this.map,
            position: [pItem.gpsPoint.longitude, pItem.gpsPoint.latitude],
            title: '线索'
          });
          this.layerEditor.leadMarkerList.push(marker);
          //记录标记的点
          // 创建信息窗口
          marker.on('mouseover', () => {
            let infoWindow = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: `<div style="background-color: #fff;padding: 10px;border-radius:5px;">
                              <div>姓名：${pItem.name || '无名氏'}</div>
                              <div>手机：${pItem.phone || 13400000000}</div>
                              <div>地址：${pItem.address}</div>
                          </div>`,
              offset: new AMap.Pixel(-15, -25)
            });
            infoWindow.open(this.map, [pItem.gpsPoint.longitude, pItem.gpsPoint.latitude]);
            marker.on('mouseout', () => {
              infoWindow.close(this.map, [pItem.gpsPoint.longitude, pItem.gpsPoint.latitude]);
            });
          });
        });
      });
      // });
    },
    // 生成行政区域-省份图层
    initPro(code, dep) {
      dep = typeof dep == 'undefined' ? 2 : dep;
      this.disProvince && this.disProvince.clearMap();
      this.disProvince = new AMap.DistrictLayer.Province({
        zIndex: 12,
        adcode: [code],
        depth: dep,
        styles: {
          fill: properties => {
            // properties为可用于做样式映射的字段，包含
            // NAME_CHN:中文名称
            // adcode_pro
            // adcode_cit
            // adcode
            return this.getColorByAdcode(properties.adcode);
          },
          'province-stroke': 'cornflowerblue',
          'city-stroke': 'white', // 中国地级市边界
          'county-stroke': 'rgba(255,255,255,0.5)' // 中国区县边界
        }
      });
      this.disProvince.add(this.map);
    },
    //随机生成行政区域颜色
    getColorByAdcode(adcode) {
      let colors = {};
      if (!colors[adcode]) {
        let gb = Math.random() * 155 + 50;
        colors[adcode] = 'rgb(' + gb + ',' + gb + ',255)';
      }
      return colors[adcode];
    },
    handleClick() {},
    tabClick(tab) {
      switch (tab.name) {
        case 'log':
          this.getLog();
          break;
        case 'contact':
          this.getContacInit();
          break;
        case 'map':
          this.initMap('mapAlert', { formData: this.mapAlertData.row }, () => {
            this.$forceUpdate();
            this.addSRmark({ name: 'mapAlert' }); //添加服务资源标点
            this.addSAmarkerAlert({ name: 'mapAlert', formData: this.mapAlertData.row }); //添加工单标点
          });
          break;
        default:
          return;
      }
    },
    //图层编辑器-切换标记
    layerEditorChange(event) {
      console.log(event, this.layerEditor.lastChecked);
      if (event) {
        //标记工单
        if (!this.layerEditor.lastChecked.includes('checkedSA') && event.includes('checkedSA')) {
          //添加工单标记
          this.addSAMarker();
        } else if (!event.includes('checkedSA')) {
          //删除工单标记
          this.layerEditor.SAmarkerList.forEach(marker => {
            marker.clearMap();
            marker = null;
          });
        }

        // //绘制自定义服务区域
        // if (event.includes('checkedSTcustom')) {
        //   // this.areahuafen();
        //   //添加自定义服务区域
        //   if (!this.layerEditor.STcustommarkerList.length) {
        //     this.areaGeo(); //添加自定义服务区域
        //   } else {
        //     this.layerEditor.STcustommarkerList.forEach(marker => {
        //       marker.show(); //显示自定义服务区域
        //     });
        //   }
        // } else {
        //   this.layerEditor.STcustommarkerList.forEach(marker => {
        //     marker.hide(); //隐藏自定义服务区域
        //   });
        // }

        // //绘制服务区域-新版tree
        // if (!this.layerEditor.lastChecked.includes('checkedST') && event.includes('checkedST')) {
        //   this.administrativeRegionQuery(); //添加服务区域
        // } else if (!event.includes('checkedST')) {
        //   this.layerEditor.administrativeRegion.forEach(districtExplorer => {
        //     this.layerEditor.administrativeRegion$('#area-tree').off(); //取消行政区域的tree组件所绑定的事件
        //     districtExplorer.clearFeaturePolygons(); //清除行政区域图层
        //     districtExplorer.clearMap(); //清除行政区域在地图上
        //   });
        // }

        // //绘制服务区域-旧版
        // if (!this.layerEditor.lastChecked.includes('checkedST') && event.includes('checkedST')) {
        //   this.getServiceTerritory(cityList => {});
        // } else if (!event.includes('checkedST')) {
        //   this.layerEditor.STmarkerList.forEach(marker => {
        //     marker.clearFeaturePolygons(); //清除服务区域
        //   });
        // }
        // //标记VIP客户
        // if (!this.layerEditor.lastChecked.includes('checkedVIP') && event.includes('checkedVIP')) {
        //   // this.getPartner();
        //   this.addContact(); //添加VIP客户
        // } else if (!event.includes('checkedVIP')) {
        //   this.layerEditor.VIPmarkerList.forEach(marker => {
        //     marker.clearMap();
        //     marker = null;
        //   });
        // }

        //标记服务资源
        if (!this.layerEditor.lastChecked.includes('checkedSR') && event.includes('checkedSR')) {
          // this.getPartner();
          this.addSRmark(); //添加服务资源
        } else if (!event.includes('checkedSR')) {
          //清空服务资源
          this.layerEditor.SRmarkerList.forEach(marker => {
            marker.clearMap();
            marker = null;
          });
        }

        // //标记线索
        // if (
        //   !this.layerEditor.lastChecked.includes('checkedLead') &&
        //   event.includes('checkedLead')
        // ) {
        //   this.addLeadMark(); //添加线索
        // } else if (!event.includes('checkedLead')) {
        //   //清空线索
        //   this.layerEditor.leadMarkerList.forEach(marker => {
        //     marker.clearMap();
        //     marker = null;
        //   });
        // }
        //记录上一次选择的
        this.layerEditor.lastChecked = event || [];
        // debugger;
      }
    },
    //添加报表层
    addLayerReport() {
      if (!this.reportData.value) {
        this.osg.toast('请选择所要添加的图层！', 'warning');
        return;
      }
      if (this.reportData.applicationFilter.find(item => item.value == this.reportData.value)) {
        this.osg.toast('已有该图层，请勿重复添加！', 'warning');
        return;
      }

      let reportItem = this.reportData.reportList.find(item => item.value == this.reportData.value);
      reportItem.name = reportItem.label;
      reportItem.show = true;
      this.reportData.applicationFilter.push(this.$util.deepCopy(reportItem));
      this.updateReportApplicationFilter(this.reportData.applicationFilter.length - 1); //更新报表过滤条件
    },
    //报表查询条件切换
    reportApplicationFilterChange(row, index) {
      this.reportData.applicationFilter[index].show = !this.reportData.applicationFilter[index]
        .show;
      this.updateReportApplicationFilter(index); //更新报表过滤条件
    },
    //删除报表查询条件
    delReportApplicationFilterBtn(index) {
      if (index == 'all') {
        this.reportData.applicationFilter = [];
        this.delReportApplicationFilter(index); //删除报表过滤条件
      } else {
        let value = this.reportData.applicationFilter.splice(index, 1)[0].value;
        this.delReportApplicationFilter(value); //删除报表过滤条件
      }
    },
    // 删除报表过滤条件
    delReportApplicationFilter(value) {
      if (value == 'all') {
        //清空标记VIP客户
        this.layerEditor.VIPmarkerList.forEach(marker => {
          marker.clearMap();
          marker = null;
        });
        //清空线索
        this.layerEditor.leadMarkerList.forEach(marker => {
          marker.clearMap();
          marker = null;
        });
      } else if (value == '2') {
        //清空标记VIP客户
        this.layerEditor.VIPmarkerList.forEach(marker => {
          marker.clearMap();
          marker = null;
        });
      } else if (value == '3') {
        //清空线索
        this.layerEditor.leadMarkerList.forEach(marker => {
          marker.clearMap();
          marker = null;
        });
      }
    },
    //更新报表过滤条件
    updateReportApplicationFilter(index) {
      //标记VIP客户
      if (this.reportData.applicationFilter[index].value == '2') {
        if (this.reportData.applicationFilter[index].show) {
          this.addContact(); //添加VIP客户
        } else {
          //清空标记VIP客户
          this.layerEditor.VIPmarkerList.forEach(marker => {
            marker.clearMap();
            marker = null;
          });
        }
      }
      //标记线索
      if (this.reportData.applicationFilter[index].value == '3') {
        if (this.reportData.applicationFilter[index].show) {
          this.addLeadMark(); //添加线索
        } else {
          //清空线索
          this.layerEditor.leadMarkerList.forEach(marker => {
            marker.clearMap();
            marker = null;
          });
        }
      }
    },
    //绘制自定义服务区域
    drawPolygon() {
      if (this.mouseTool) {
        this.mouseTool.close(true); //关闭绘制自定义图层
        this.mouseTool = null;
      }
      this.mouseTool = new AMap.MouseTool(this.map);
      this.mouseTool.polygon({
        strokeColor: '#111',
        // strokeOpacity: 1,
        strokeWeight: 2,
        strokeOpacity: 1,
        fillColor: this.customDrawData.exts.fillColor,
        fillOpacity: 0.6,
        // 线样式还支持 'dashed'
        strokeStyle: 'solid'
        // strokeStyle是dashed时有效
        // strokeDasharray: [30,10],
      });
      this.mouseTool.on('draw', event => {
        // console.log(event.obj);
        // this.areaGeoRightMenu([this.mouseTool]); //添加右键菜单
        console.log(event.obj.getPath()); //获取点标注位置
        let arr = event.obj.getPath();
        this.customDrawData.customPoints = arr.map(item => {
          return {
            longitude: item.lng,
            latitude: item.lat
          };
        });
        this.doServiceTerritoryCustomSave(data => {
          this.areaGeo(data, () => {
            this.mouseTool.close(true); //关闭绘制自定义图层
            this.mouseTool = null;
            // this.osg.toast('服务区域绘制完成！');
          });
        });

        console.log(
          arr.map(item => {
            return {
              gpsPoint: {
                longitude: item.lng,
                latitude: item.lat
              }
            };
          })
        );
      });
    },
    //清除绘制自定义服务区域
    closeDraw() {
      this.mouseTool.close(true);
    },
    //省区边界
    areahuafen() {
      AMapUI.load(['ui/misc/PathSimplifier', 'lib/$'], (PathSimplifier, $) => {
        if (!PathSimplifier.supportCanvas) {
          alert('当前环境不支持 Canvas！');
          return;
        }

        //just some colors
        var colors = [
          '#3366cc',
          '#dc3912',
          '#ff9900',
          '#109618',
          '#990099',
          '#0099c6',
          '#dd4477',
          '#66aa00',
          '#b82e2e',
          '#316395',
          '#994499',
          '#22aa99',
          '#aaaa11',
          '#6633cc',
          '#e67300',
          '#8b0707',
          '#651067',
          '#329262',
          '#5574a6',
          '#3b3eac'
        ];

        var pathSimplifierIns = new PathSimplifier({
          //autoSetFitView:false,
          map: this.map, //所属的地图实例

          getPath: function(pathData, pathIndex) {
            return pathData.path;
          },
          getHoverTitle: function(pathData, pathIndex, pointIndex) {
            if (pointIndex >= 0) {
              //point
              return pathData.name + '，点:' + pointIndex + '/' + pathData.path.length;
            }

            return pathData.name + '，打卡次数' + pathData.path.length;
          },
          renderOptions: {
            renderAllPointsIfNumberBelow: 200,
            pathTolerance: 1,
            keyPointTolerance: 10,
            keyPointStyle: {
              fillStyle: '#ccc',
              radius: 1,
              lineWidth: 1
            },
            startPointStyle: null,
            endPointStyle: null,
            pathLineHoverStyle: {
              strokeStyle: '#000000'
            },
            pathLineSelectedStyle: {
              dirArrowStyle: null,
              strokeStyle: '#000000',
              borderStyle: 'orange',
              borderWidth: 2
            },
            getPathStyle: function(pathItem, zoom) {
              var color = colors[pathItem.pathIndex % colors.length],
                lineWidth = Math.round(4 * Math.pow(1.1, zoom - 3));

              return {
                pathLineStyle: {
                  strokeStyle: color,
                  lineWidth: lineWidth
                },
                pathLineSelectedStyle: {
                  lineWidth: lineWidth + 2
                },
                pathNavigatorStyle: {
                  fillStyle: color
                }
              };
            }
          }
        });

        window.pathSimplifierIns = pathSimplifierIns;

        $('<div id="loadingTip">加载数据，请稍候...</div>').appendTo(document.body);

        $.getJSON('https://a.amap.com/amap-ui/static/data/prov-borders.json', function(d) {
          $('#loadingTip').remove();
          pathSimplifierIns.setData(d);
        });

        pathSimplifierIns.on('selectedPathIndexChanged', function(e, info) {});

        pathSimplifierIns.on('pointClick pointMouseover pointMouseout', function(e, record) {
          //console.log(e.type, record);
        });

        pathSimplifierIns.on('pathClick pathMouseover pathMouseout', function(e, record) {
          //console.log(e.type, record);
        });
      });
    },
    //查询自定义服务区域
    getServiceTerritoryCustom() {
      this.osg.ajax(
        'basic/serviceTerritoryCustom/query.do',
        {
          sortField: 'createTime',
          sortOrder: 'desc',
          'in:state|array-integer#and': '1'
        },
        res => {
          this.customizeAreaList = [
            {
              name: '全部自定义服务区域',
              _id: 'all',
              label: '全部自定义服务区域',
              children: res.data.filter(item => item.name)
            }
          ];
          console.log(this.customizeAreaList);
        },
        { noload: true }
      );
    },
    //保存自定义服务区域
    doServiceTerritoryCustomSave(callback) {
      this.osg.ajax(
        'basic/serviceTerritoryCustom/upsert.do',
        { data: JSON.stringify(this.customDrawData) },
        res => {
          // this.customizeAreaList
          if (callback) callback(res.data);
          this.defaultChecked = this.$refs.areaTree.getCheckedKeys() || [];
          this.getServiceTerritoryCustom();
          this.openCustomDrawDetail = false;
          this.osg.toast('保存成功!');
        }
      );
    },
    //编辑自定义服务区域信息弹窗按钮
    doServiceTerritoryCustomBtn() {
      if (this.osg.isRepeatClick('doServiceTerritoryCustomBtn', 5000)) {
        return;
      }
      if (!this.customDrawData.name) {
        this.osg.toast('请输入名称！', 'warning');
        return;
      }
      this.doServiceTerritoryCustomSave(data => {
        let that = this;
        //将旧的删除
        this.layerEditor.STcustommarkerList.forEach((item, index) => {
          if (item && item._id == data._id) {
            item.setOptions({
              strokeColor: '#111',
              strokeWeight: 2,
              fillColor: data.exts ? data.exts.fillColor || '#FB4300' : '#FB4300',
              fillOpacity: 0.6
            });
            // item.hide();
            // that.layerEditor.STcustommarkerList.splice(index, 1);
            // debugger;
            // that.defaultChecked.splice(that.defaultChecked.indexOf(item._id), 1);
            // that.$forceUpdate();
          }
        });
        this.openCustomDrawDetail = false;
      });
    },
    //覆盖物
    areaGeo(polylineData, callback) {
      // 创建覆盖物群组，传入覆盖物组成的数组
      let overlayGroup;
      let polyline = new AMap.Polygon({
        path: polylineData.customPoints.map(
          item => new AMap.LngLat(String(item.longitude), String(item.latitude))
        )
      });
      let overlayGroupArr = [polyline];
      this.areaGeoRightMenu(overlayGroupArr, polylineData); //给自定义服务区域添加右键菜单
      // 创建覆盖物群组，传入覆盖物组成的数组
      overlayGroup = new AMap.OverlayGroup(overlayGroupArr);
      // 对此覆盖物群组设置同一属性
      overlayGroup.setOptions({
        strokeColor: '#111',
        strokeWeight: 2,
        fillColor: polylineData.exts ? polylineData.exts.fillColor || '#FB4300' : '#FB4300',
        fillOpacity: 0.6
      });
      //文档地址  https://developer.amap.com/api/javascript-api/reference/overlay#polygon
      // 统一添加到地图实例上
      this.map.add(overlayGroup);

      //将旧的删除，后面会新增新的服务区域
      this.layerEditor.STcustommarkerList.find((item, index) => {
        if (item && item._id == polylineData._id) {
          this.layerEditor.STcustommarkerList.splice(index, 1);
        }
      });

      overlayGroup._id = polylineData._id;

      //存储自定义服务区域
      this.layerEditor.STcustommarkerList.push(overlayGroup);

      if (callback) callback();

      //       var polyline3 = new AMap.Polyline({
      //     path: [
      //         new AMap.LngLat('130.387271','39.912501'),
      //         new AMap.LngLat('136.398258','39.904600')
      //     ]
      // });

      // // 添加新的覆盖物到群组
      // overlayGroup.addOverlay(polyline3);
    },
    //覆盖物的右键菜单
    areaGeoRightMenu(overlayGroupArr, data) {
      let that = this;
      console.log(overlayGroupArr, 'overlayGroupArr');
      overlayGroupArr.forEach(lItem => {
        //创建右键菜单
        let contextMenu = new AMap.ContextMenu();
        //右键放大
        contextMenu.addItem(
          '放大一级',
          function() {
            that.map.zoomIn();
          },
          0
        );
        //右键缩小
        contextMenu.addItem(
          '缩小一级',
          function() {
            that.map.zoomOut();
          },
          1
        );
        //右键缩小
        contextMenu.addItem(
          '隐藏',
          function() {
            // that.map.zoomOut();
            lItem.hide();
          },
          1
        );
        if (data._id) {
          //右键删除
          contextMenu.addItem(
            '删除',
            function() {
              // that.map.zoomOut();
              that.osg.confirm(`是否确认${data.name}？`, () => {
                that.osg.ajax(
                  'basic/serviceTerritoryCustom/remove/' + data._id + '.do',
                  null,
                  () => {
                    that.getServiceTerritoryCustom();
                    that.osg.toast(`已删除${data.name}`);
                    lItem.hide();
                  }
                );
              });
            },
            1
          );
        }
        //右键开始编辑
        contextMenu.addItem(
          '开始编辑',
          function() {
            lItem.hide();
            // 创建编辑覆盖物
            that.createEditOverlay(data);
          },
          1
        );
        //右键修改信息
        contextMenu.addItem(
          '修改信息',
          () => {
            this.openCustomDrawDetail = true;
            this.customDrawData = data;
          },
          1
        );
        lItem.on('rightclick', function(e) {
          contextMenu.open(that.map, e.lnglat);
          console.log(e, 'right@@');
        });
      });
    },
    //创建编辑覆盖物
    createEditOverlay(data) {
      let polygon = new AMap.Polygon({
        path: data.customPoints.map(item => {
          return [item.longitude, item.latitude];
        }),
        strokeColor: 'black',
        strokeWeight: 1,
        strokeOpacity: 1,
        fillOpacity: 0.6,
        fillColor: data.exts ? data.exts.fillColor || '#FB4300' : '#FB4300',
        zIndex: 50
      });
      this.map.add(polygon);
      // 缩放地图到合适的视野级别
      this.map.setFitView([polygon]);
      let polyEditor = new AMap.PolygonEditor(this.map, polygon);
      //创建右键菜单
      let contextMenu = new AMap.ContextMenu();
      //右键结束编辑
      contextMenu.addItem(
        '结束编辑',
        () => {
          polyEditor.close();
          this.customDrawData = this.$util.deepCopy(data);
          this.customDrawData.customPoints = polyEditor.au[0].map(item => {
            return {
              longitude: item.lng,
              latitude: item.lat
            };
          });
          // debugger;
          // let arr = event.obj.getPath();
          // this.customDrawData.customPoints = arr.map(item => {
          //   return {
          //     longitude: item.lng,
          //     latitude: item.lat
          //   };
          // });
          this.doServiceTerritoryCustomSave(data => {
            this.areaGeo(data, () => {
              polygon.hide();
              // this.osg.toast('服务区域绘制完成！');
            });
          });
        },
        1
      );
      polygon.on('rightclick', e => {
        contextMenu.open(this.map, e.lnglat);
        console.log(contextMenu, e, 'right@@createEditOverlay');
      });
      polyEditor.open();
    },
    //勾选自定义服务区域
    handleCheckChange(event, isCheck) {
      if (!event.customPoints) return;
      // let checkArr = this.$refs.areaTree.getCheckedKeys();
      let cover = this.layerEditor.STcustommarkerList.find(item => item._id == event._id);
      if (cover) {
        if (isCheck) {
          cover.show();
        } else {
          cover.hide();
        }
      } else {
        this.areaGeo(event);
      }
      return;
      // let check = this.$refs.areaTree.getCheckedKeys(); //被勾选的
      let beenRendered = this.layerEditor.STmarkerList[0]
        ? Object.keys(this.layerEditor.STmarkerList[0]._areaNodeCache)
        : []; //已经呈现在页面的服务区域
      console.log(beenRendered);

      if (check.length && !beenRendered.length) {
        // debugger;

        //如果第一次勾选，则渲染服务区域
        this.duoquyu([event.id]);
      } else if (!check.length && beenRendered.length) {
        // debugger;

        //如果取消最后一次勾选，清除服务区域
        this.layerEditor.STmarkerList[
          this.layerEditor.STmarkerList.length - 1
        ].clearFeaturePolygons(); //清除服务区域
      } else {
        // debugger;

        for (let i = 0; i < beenRendered.length - 1; i++) {
          debugger;
          if (!check.includes(+beenRendered[i])) {
            // this.layerEditor.STmarkerList[
            //   this.layerEditor.STmarkerList.length - 1
            // ].clearFeaturePolygons(); //清除服务区域

            this.layerEditor.STmarkerList.forEach(marker => {
              // beenRendered
              if (beenRendered[i] == marker._areaNodesForLocating[0].adcode) {
                this.duoquyu([beenRendered[i]]);
              }
              // console.log(marker._areaNodesForLocating[0].adcode, 'marker');
            });
          }
        }
      }

      return;
      if (check.includes(+beenRendered[beenRendered.length - 1])) {
        // debugger;
        this.layerEditor.STmarkerList[
          this.layerEditor.STmarkerList.length - 1
        ].clearFeaturePolygons(); //清除服务区域
      } else {
        this.duoquyu([event.id], () => {
          // +beenRendered[beenRendered.length - 1]
          console.log(this.layerEditor.STmarkerList);

          // this.layerEditor.STmarkerList.filter(marker=>{
          // })
          this.layerEditor.STmarkerList.forEach(marker => {
            // beenRendered
            console.log(marker._areaNodesForLocating[0].adcode, 'marker');

            // marker.clearFeaturePolygons(); //清除服务区域
            // if (marker._areaNodesForLocating)
            // console.log(marker._areaNodesForLocating[0].adcode, 'marker');
          });
        });
      }
    },
    //多区域
    duoquyu(areaList, areaId) {
      areaList = areaList.filter(
        cityCode =>
          !(
            cityCode.startsWith('81') ||
            cityCode.startsWith('82') ||
            cityCode.startsWith('310100') ||
            cityCode.startsWith('110100')
          )
      );
      console.log(areaList);
      let that = this;
      var colors = [
        '#3366cc',
        '#dc3912',
        '#ff9900',
        '#109618',
        '#990099',
        '#0099c6',
        '#dd4477',
        '#66aa00',
        '#b82e2e',
        '#316395',
        '#994499',
        '#22aa99',
        '#aaaa11',
        '#6633cc',
        '#e67300',
        '#8b0707',
        '#651067',
        '#329262',
        '#5574a6',
        '#3b3eac'
      ];

      AMapUI.loadUI(['geo/DistrictExplorer'], DistrictExplorer => {
        //创建一个实例
        var districtExplorer = new DistrictExplorer({
          map: this.map
        });

        function renderAreaNode(areaNode) {
          // let df = areaNode;
          // debugger;
          //绘制子区域
          districtExplorer.renderSubFeatures(areaNode, function(feature, i) {
            // let ff = areaNode;
            var fillColor = colors[i % colors.length];
            var strokeColor = colors[colors.length - 1 - (i % colors.length)];
            // debugger;
            return {
              cursor: 'default',
              bubble: true,
              strokeColor: strokeColor, //线颜色
              strokeOpacity: 1, //线透明度
              strokeWeight: 1, //线宽
              fillColor: fillColor, //填充色
              fillOpacity: 0.35 //填充透明度
            };
          });

          var fillColor = colors[Math.floor(Math.random() * colors.length)];
          var strokeColor = colors[Math.floor(Math.random() * colors.length)];
          //绘制父区域
          districtExplorer.renderParentFeature(areaNode, {
            cursor: 'default',
            bubble: true,
            strokeColor: strokeColor, //线颜色
            strokeOpacity: 1, //线透明度
            strokeWeight: 1, //线宽
            fillColor: fillColor, //填充色
            fillOpacity: 0.35 //填充透明度
          });
        }

        var adcodes = areaList || [
          // 110000,
          // 310000,
          // 330100,
          // 341200,
          // 610100,
          // 140100,
          // 500000,
          // 440100
          430102,
          341282
        ]; //TODO:写死的服务区域
        // var adcodes =[441901] || [cityList[0]];
        // debugger;

        // loadMultiAreaNodes
        // loadAreaNode
        districtExplorer.loadMultiAreaNodes(adcodes, (error, areaNodes) => {
          // let s = adcodes;
          // debugger;
          //清除已有的绘制内容
          districtExplorer.clearFeaturePolygons();
          if (!areaNodes) return;
          for (var i = 0, len = areaNodes.length; i < len; i++) {
            renderAreaNode(areaNodes[i]);
          }

          //更新地图视野
          that.map.setFitView(districtExplorer.getAllFeaturePolygons());

          //添加服务区域显示
          districtExplorer._id = areaId;
          this.layerEditor.STmarkerList.push(districtExplorer);
          // if (callback) callback();
        });
      });
    },
    //获取服务区域
    getServiceTerritory(callback) {
      var params = {
        page: this.serviceTerritories.page || 1,
        rows: 20,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        params,
        res => {
          console.log(res.data);
          this.serviceTerritories = res;
          // let cityList = (res.data = res.data.map(item => item.city));
          // cityList.flat()
          if (callback) callback();
        },
        { noload: true }
      );
    },
    //选择服务区域
    handleSTCheckChange(event, isCheck) {
      // let cover = this.layerEditor.STmarkerList.find(item => item._id == event._id);
      let coverIndex = this.layerEditor.STmarkerList.findIndex(item => item._id == event._id);
      if (isCheck) {
        this.duoquyu(event.district.flat(), event._id); //添加服务区域
      } else {
        this.layerEditor.STmarkerList[coverIndex].clearFeaturePolygons(); //清除服务区域
        this.layerEditor.STmarkerList.splice(coverIndex, 1); //并删除
      }
    },
    //清空所有服务区域
    clearAllST() {
      this.layerEditor.STmarkerList.forEach(item => item.clearFeaturePolygons());
      this.layerEditor.STmarkerList = [];
      this.$refs.areaSTtree.setCheckedKeys([]);
    },
    getPartner(callback) {
      var params = {
        page: 1,
        rows: 20,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/partner/query.do',
        params,
        res => {
          if (callback) callback(res.data);
        },
        { noload: true }
      );
    },
    //行政区查询  https://developer.amap.com/api/javascript-api/guide/services/district-search/
    administrativeRegionQuery() {
      let that = this;
      //just some colors
      var colors = [
        '#3366cc',
        '#dc3912',
        '#ff9900',
        '#109618',
        '#990099',
        '#0099c6',
        '#dd4477',
        '#66aa00',
        '#b82e2e',
        '#316395',
        '#994499',
        '#22aa99',
        '#aaaa11',
        '#6633cc',
        '#e67300',
        '#8b0707',
        '#651067',
        '#329262',
        '#5574a6',
        '#3b3eac'
      ];

      AMapUI.load(['ui/geo/DistrictExplorer', 'lib/$'], function(DistrictExplorer, $) {
        //创建一个实例
        var districtExplorer = (window.districtExplorer = new DistrictExplorer({
          eventSupport: true, //打开事件支持
          map: that.map
        }));

        //当前聚焦的区域
        var currentAreaNode = null;

        //鼠标hover提示内容
        var $tipMarkerContent = $('<div class="tipMarker top"></div>');

        var tipMarker = new AMap.Marker({
          content: $tipMarkerContent.get(0),
          offset: new AMap.Pixel(0, 0),
          bubble: true
        });

        //根据Hover状态设置相关样式
        function toggleHoverFeature(feature, isHover, position) {
          isHover ? tipMarker.add(that.map) : tipMarker.clearMap();

          if (!feature) {
            return;
          }

          var props = feature.properties;

          if (isHover) {
            //更新提示内容
            $tipMarkerContent.html(props.adcode + ': ' + props.name);
            //更新位置
            tipMarker.setPosition(position || props.center);
          }

          $('#area-tree')
            .find('h2[data-adcode="' + props.adcode + '"]')
            .toggleClass('hover', isHover);

          //更新相关多边形的样式
          var polys = districtExplorer.findFeaturePolygonsByAdcode(props.adcode);
          for (var i = 0, len = polys.length; i < len; i++) {
            polys[i].setOptions({
              fillOpacity: isHover ? 0.5 : 0.2
            });
          }
        }

        //监听feature的hover事件
        districtExplorer.on('featureMouseout featureMouseover', function(e, feature) {
          toggleHoverFeature(
            feature,
            e.type === 'featureMouseover',
            e.originalEvent ? e.originalEvent.lnglat : null
          );
        });

        //监听鼠标在feature上滑动
        districtExplorer.on('featureMousemove', function(e, feature) {
          //更新提示位置
          tipMarker.setPosition(e.originalEvent.lnglat);
        });

        //feature被点击
        districtExplorer.on('featureClick', function(e, feature) {
          var props = feature.properties;
          //如果存在子节点
          // if (props.childrenNum > 0) {
          //切换聚焦区域
          switch2AreaNode(props.adcode);
          // }
        });

        //外部区域被点击
        districtExplorer.on('outsideClick', function(e) {
          districtExplorer.locatePosition(
            e.originalEvent.lnglat,
            function(error, routeFeatures) {
              if (routeFeatures && routeFeatures.length > 1) {
                //切换到省级区域
                switch2AreaNode(routeFeatures[1].properties.adcode);
              } else {
                //切换到全国
                switch2AreaNode(100000);
              }
            },
            {
              levelLimit: 2
            }
          );
        });

        //绘制区域面板的节点
        function renderAreaPanelNode(ele, props, color) {
          // debugger;
          var $box = $('<li/>').addClass('lv_' + props.level);

          var $h2 = $('<h2/>')
            .addClass('lv_' + props.level)
            .attr({
              'data-adcode': props.adcode,
              'data-level': props.level,
              'data-children-num': props.childrenNum || void 0,
              'data-center': props.center.join(',')
            })
            .html(props.name)
            .appendTo($box);

          if (color) {
            $h2.css('borderColor', color);
          }

          //如果存在子节点
          if (props.childrenNum > 0) {
            //显示隐藏
            $('<div class="showHideBtn"></div>').appendTo($box);

            //子区域列表
            $('<ul/>')
              .addClass('sublist lv_' + props.level)
              .appendTo($box);

            $('<div class="clear"></div>').appendTo($box);

            if (props.level !== 'country') {
              $box.addClass('hide-sub');
            }
          }

          $box.appendTo(ele);
        }

        //TODO:填充某个节点的子区域列表-王梓汆
        function renderAreaPanel(areaNode) {
          var props = areaNode.getProps();

          var $subBox = $('#area-tree')
            .find('h2[data-adcode="' + props.adcode + '"]')
            .siblings('ul.sublist');

          if (!$subBox.length && props.childrenNum) {
            //父节点不存在，先创建
            renderAreaPanelNode($('#area-tree'), props);
            $subBox = $('#area-tree').find('ul.sublist');
          }
          if ($subBox.attr('data-loaded') === 'rendered') {
            return;
          }

          $subBox.attr('data-loaded', 'rendered');

          var subFeatures = areaNode.getSubFeatures();

          //填充子区域
          for (var i = 0, len = subFeatures.length; i < len; i++) {
            renderAreaPanelNode(
              $subBox,
              areaNode.getPropsOfFeature(subFeatures[i]),
              colors[i % colors.length]
            );
          }
        }

        //绘制某个区域的边界
        function renderAreaPolygons(areaNode) {
          //更新地图视野
          that.map.setBounds(areaNode.getBounds(), null, null, true);

          //清除已有的绘制内容
          districtExplorer.clearFeaturePolygons();

          //绘制子区域
          districtExplorer.renderSubFeatures(areaNode, function(feature, i) {
            var fillColor = colors[i % colors.length];
            var strokeColor = colors[colors.length - 1 - (i % colors.length)];

            return {
              cursor: 'default',
              bubble: true,
              strokeColor: strokeColor, //线颜色
              strokeOpacity: 1, //线透明度
              strokeWeight: 1, //线宽
              fillColor: fillColor, //填充色
              fillOpacity: 0.35 //填充透明度
            };
          });

          //绘制父区域
          districtExplorer.renderParentFeature(areaNode, {
            cursor: 'default',
            bubble: true,
            strokeColor: 'black', //线颜色
            strokeOpacity: 1, //线透明度
            strokeWeight: 1, //线宽
            fillColor: areaNode.getSubFeatures().length ? null : colors[0], //填充色
            fillOpacity: 0.35 //填充透明度
          });
        }

        //切换区域后刷新显示内容
        function refreshAreaNode(areaNode) {
          districtExplorer.setHoverFeature(null);

          renderAreaPolygons(areaNode);

          //更新选中节点的class
          var $nodeEles = $('#area-tree').find('h2');

          $nodeEles.removeClass('selected');

          var $selectedNode = $nodeEles
            .filter('h2[data-adcode=' + areaNode.getAdcode() + ']')
            .addClass('selected');

          //展开下层节点
          $selectedNode.closest('li').removeClass('hide-sub');

          //折叠下层的子节点
          $selectedNode
            .siblings('ul.sublist')
            .children()
            .addClass('hide-sub');
        }

        //切换区域
        function switch2AreaNode(adcode, callback) {
          if (currentAreaNode && '' + currentAreaNode.getAdcode() === '' + adcode) {
            return;
          }

          loadAreaNode(adcode, function(error, areaNode) {
            if (error) {
              if (callback) {
                callback(error);
              }

              return;
            }

            currentAreaNode = window.currentAreaNode = areaNode;

            //设置当前使用的定位用节点
            districtExplorer.setAreaNodesForLocating([currentAreaNode]);

            refreshAreaNode(areaNode);

            if (callback) {
              callback(null, areaNode);
            }
          });
        }

        //加载区域
        function loadAreaNode(adcode, callback) {
          districtExplorer.loadAreaNode(adcode, function(error, areaNode) {
            if (error) {
              if (callback) {
                callback(error);
              }

              console.error(error);

              return;
            }

            renderAreaPanel(areaNode);

            if (callback) {
              callback(null, areaNode);
            }
          });
        }

        $('#area-tree').on('mouseenter mouseleave', 'h2[data-adcode]', function(e) {
          if (e.type === 'mouseleave') {
            districtExplorer.setHoverFeature(null);
            return;
          }

          var adcode = $(this).attr('data-adcode');

          districtExplorer.setHoverFeature(currentAreaNode.getSubFeatureByAdcode(adcode));
        });

        $('#area-tree').on('click', 'h2', function() {
          var adcode = $(this).attr('data-adcode');
          switch2AreaNode(adcode);
        });

        $('#area-tree').on('click', '.showHideBtn', function() {
          var $li = $(this).closest('li');

          $li.toggleClass('hide-sub');

          if (!$li.hasClass('hide-sub')) {
            //子节点列表被展开
            var $subList = $li.children('ul.sublist');

            //尚未加载
            if (!$subList.attr('data-loaded')) {
              $subList.attr('data-loaded', 'loading');

              $li.addClass('loading');

              //加载
              loadAreaNode($li.children('h2').attr('data-adcode'), function() {
                $li.removeClass('loading');
              });
            }
          }
        });

        //全国
        switch2AreaNode(341200, () => {
          that.layerEditor.administrativeRegion.push(districtExplorer);
          that.layerEditor.administrativeRegion$ = $;
        });
      });
    },
    //初始化工单
    getSAinit(sid, callback) {
      this.osg.getFields(
        'serviceAppointment',
        () => {
          this.getSA(sid, callback);
        },
        this
      );
    },
    getSA(sid, callback) {
      this.osg.ajax(`basic/serviceAppointment/queryById/${sid}.do`, {}, res => {
        let row = res.data.serviceAppointment;
        //解析json格式area
        if (this.$util.isJson(row.area)) {
          row.area = JSON.parse(row.area);
        }

        row.gpsPoint = row.gpsPoint || {};
        this.$util.renderExtField(this.extFields, row);
        this.formData = row;
        if (callback) callback(row);
      });
    },
    //获取地理编码
    async getGeocode() {
      if (this.formData.area[0] && this.formData.area[1]) {
        var citys = await this.$util.getCity(this.formData.area[0]);
        var cityName = '';
        for (var city of citys) {
          if (city._id == this.formData.area[1]) {
            cityName = city.name;
            break;
          }
        }
        this.osg.geocode(cityName + this.formData.address, res => {
          this.formData.gpsPoint = {
            longitude: res.location.split(',')[0],
            latitude: res.location.split(',')[1]
          };
          this.$forceUpdate();
        });
      }
    },
    //保存工单
    doSaveSA() {
      if (this.osg.validate()) {
        if (this.osg.isRepeatClick('doSaveSA', 5000)) {
          return;
        }
        var params = this.formData;
        params.area = params.area || [];
        if (params.area.length > 0) {
          params.province = params.area[0] || '';
          if (params.area.length > 1) {
            params.city = params.area[1] || '';
            if (params.area.length > 2) {
              params.district = params.area[2] || '';
              if (params.area.length > 3) {
                params.subdistrict = params.area[3] || '';
              }
            }
          }
        }
        // this.$util.saveExtField(this.extFields, params);
        // 自定义字段转换值
        this.$util.saveFormatExtField(this.extFields, params);
        this.osg.ajax(
          'basic/serviceAppointment/upsert.do',
          { data: JSON.stringify(params) },
          res => {
            this.osg.toast('保存成功！');
          }
        );
      }
    },
    //工单日志
    getLog() {
      if (!this.formData._id) return;
      this.log.searchDate = this.log.searchDate || [];
      this.osg.ajax(
        'tenantLog/query.do',
        {
          sid: this.formData._id,
          smodule: 'serviceAppointment',
          _all: '1',
          'regex:title|string#or': this.log.searchValue,
          'regex:content|string#or': this.log.searchValue,
          'gte:createTime|datetime#and': this.log.searchDate[0],
          'lte:createTime|datetime#and': this.log.searchDate[1],
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.log.fpi = res;
        },
        { noload: true }
      );
    },
    //客户初始化
    getContacInit() {
      this.osg.getFields(
        'contacts',
        () => {
          this.getContactData();
        },
        this,
        'contactsExtFields'
      );
    },
    //获取客户列表-根据工单id
    getContactData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 10,
        'in:state|integer#and': 1,
        // 'regex:name|string#or': this.searchValue,
        // 'regex:phone|string#or': this.searchValue,
        // 'regex:email|string#or': this.searchValue,
        'in:_id|array#and': this.formData.contactIds.join(','),
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      // $that.getParams(params);
      this.osg.ajax('basic/contacts/query.do', params, res => {
        // this.refresh = false;
        this.fpi = res;
        // this.refresh = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    pageSizeChange(pageSize, fpiName, fn) {
      fpiName = fpiName || 'fpi';
      this[fpiName].rows = pageSize;
      if (fpiName == 'fpi') {
        this.getContactData();
      } else {
        fn();
      }
    },
    pageChange(currentPage, fpiName, fn) {
      fpiName = fpiName || 'fpi';
      this[fpiName].page = currentPage;
      if (fpiName == 'fpi') {
        this.getContactData();
      } else {
        if (fpiName == 'serviceTerritories') {
          this.defaultSTChecked = this.layerEditor.STmarkerList.map(item => item._id); //给服务区域设置默认值
        }
        fn();
      }
    }
  }
};
</script>
<style scoped>
.container {
  height: 100%;
}
#map {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.closeHover:hover {
  color: #409eff;
}
</style>
<style lang="scss">
.map-area-tree-wrapper {
  position: relative;
  height: 300px;
  #outer-box {
    height: 100%;
    padding-right: 300px;
  }
  #container {
    height: 100%;
    width: 100%;
  }
  #panel {
    position: absolute;
    top: 0px;
    bottom: 0;
    right: 0;
    height: 100%;
    overflow: auto;
    width: 300px;
    z-index: 999;
    border-left: 1px solid #eaeaea;
    background: #fff;
  }
  .scrollbar1::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #fff;
  }
  .scrollbar1::-webkit-scrollbar {
    width: 6px;
    background-color: #fff;
  }
  .scrollbar1::-webkit-scrollbar-thumb {
    background-color: #aaa;
  }
  .clear {
    clear: both;
  }
  .tipMarker {
    color: #555;
    background-color: rgba(255, 254, 239, 0.8);
    border: 1px solid #7e7e7e;
    padding: 2px 6px;
    font-size: 12px;
    white-space: nowrap;
    display: inline-block;
  }
  .tipMarker:before,
  .tipMarker:after {
    content: '';
    display: block;
    position: absolute;
    margin: auto;
    width: 0;
    height: 0;
    border: solid transparent;
    border-width: 5px 5px;
  }
  .tipMarker.top {
    transform: translate(-50%, -110%);
  }
  .tipMarker.top:before,
  .tipMarker.top:after {
    bottom: -9px;
    left: 0;
    right: 0;
    border-top-color: rgba(255, 254, 239, 0.8);
  }
  .tipMarker.top:before {
    bottom: -10px;
    border-top-color: #7e7e7e;
  }
  #area-tree h2 {
    display: inline-block;
    font-weight: 500;
    font-size: 13px;
    padding: 3px 5px;
    margin: 0;
    border: 1px solid #2ca02c;
    border-width: 1px 3px;
    cursor: pointer;
  }
  #area-tree h2:hover,
  #area-tree h2.hover,
  #area-tree h2.selected {
    background: #3366cc;
    color: #fff;
  }
  #area-tree h2.lv_outside {
    border-color: #666;
    padding: 3px 10px;
  }
  #area-tree h2.lv_country {
    border-color: #d62728;
    padding: 3px 27px;
    margin: 5px 0;
  }
  #area-tree h2.lv_province {
    border-color: #ff7f0e;
    padding: 3px 10px;
  }
  #area-tree h2.lv_district {
    border-color: #dd4477;
  }
  #area-tree ul {
    margin-left: 23px;
    clear: both;
  }
  #area-tree li {
    float: left;
    margin: 5px 5px 0 0;
    font-size: 12px;
  }
  #area-tree li.lv_province {
    margin: 5px 5px 5px 0;
  }
}
</style>
<style>
.amap-logo,
.amap-copyright {
  opacity: 0;
}
.amap-btn-fsgo {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 9px 15px;
  font-size: 14px;
  border-radius: 4px;
}
#mapAlert {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
#app #mapAler-dialog .el-dialog__header {
  flex: 1;
  padding: 20px 50px;
  border-bottom: none;
  /* overflow-y: auto; */
}
#app #mapAler-dialog .el-dialog {
  width: 70vw;
}
#app #mapAler-dialog .el-dialog__body {
  display: none;
}
#app .mapAler-dialog-noneFooter .el-dialog__footer {
  display: none;
}
.map-wrapper-c .el-tabs__content {
  height: calc(80vh - 147px);
  overflow-y: auto;
}
</style>
